/**
 * This is separate from the panel-config to avoid circular reference - the grid uses this for saved views
 */
export const DistributionsKey = 'distributions-4s5m0' // <-- DO NOT CHANGE THIS. The layout manager depends on this value.
export const DistributionsMainGridKey = `${DistributionsKey}-MainGrid`
export const DistributionsAccruedInterestGridKey = `${DistributionsKey}-AccruedInterestGrid`
export const DistributionsFactoryHistoryGridKey = `${DistributionsKey}-FactoryHistoryGrid`
